import { render, staticRenderFns } from "./PlayersList.vue?vue&type=template&id=5af1916e&scoped=true"
import script from "./PlayersList.js?vue&type=script&lang=js&external"
export * from "./PlayersList.js?vue&type=script&lang=js&external"
import style0 from "./PlayersList.vue?vue&type=style&index=0&id=5af1916e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1916e",
  null
  
)

export default component.exports